import React, { memo } from 'react';
import { Helmet } from 'react-helmet-async';
import { ScrollToTop } from '@/features';
import styles from './Context.module.less';

type ContextProps = {
  children: React.ReactNode;
  title: string;
};

export const Context = memo(({ children, title = '' }: ContextProps) => {
  return (
    <>
      <ScrollToTop />
      <Helmet title={title} />
      <div className={styles.container}>{children}</div>
    </>
  );
});
